import { Box } from "@mui/material";
import Text from "../ui/Text";

const DateChip = ({ date }) => {
  const getDisplayText = (date) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return "Today";
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return "Tomorrow";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    }
  };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "black",
        borderRadius: "32px",
        padding: "4px 12px",
        height: "15px",
        lineHeight: "100%",
      }}
    >
      <Text variant="paragraph2" color="white">
        {getDisplayText(new Date(date))}
      </Text>
    </Box>
  );
};

export default DateChip;
